export { default } from './SWExpandingCard';
